module.exports = __webpack_public_path__ + "static/media/SPONSORS (5).1898a036.png";